/** Numeric team id from localStorage (for API query params). */
export function getSelectedTeamNumericId() {
  try {
    const raw = typeof window !== "undefined" ? localStorage.getItem("selectedTeamData") : null;
    if (!raw) return null;
    const data = JSON.parse(raw);
    const id = data?.id ?? data?._id;
    return id != null ? id : null;
  } catch {
    return null;
  }
}
